/**
 * ttx.chart — ECharts 桥接（薄封装层）
 *
 * 依赖 window.echarts，由宿主工程（core）的 index.js 将 echarts 挂到 window 上。
 * SDK 本身不打包 echarts（rollup external），也不 import echarts。
 *
 * 用法：
 *   const chart = ttx.chart.init(dom);
 *   chart.setOption({...});
 *   chart.dispose();
 *
 * 快捷方法：
 *   ttx.chart.bar(dom, { categories, series })
 *   ttx.chart.line(dom, { categories, series })
 *   ttx.chart.pie(dom, { data })
 */

window.ttx = window.ttx || {};
ttx.chart = ttx.chart || {};

function getEcharts() {
    var e = window.echarts;
    if (!e || !e.init) throw new Error('window.echarts 未挂载，请在 core 入口 import "echarts" 并挂到 window');
    return e;
}

// ── 自适应容器 resize（内置到 init）─────────────────────────────────────────

function _autoResize(chart, dom) {
    if (typeof ResizeObserver === 'undefined') return;
    var timer = null;
    var ro = new ResizeObserver(function () {
        if (!chart.isDisposed()) {
            // debounce：侧边栏 transition 0.25s，延迟确保动画结束后取最终尺寸
            clearTimeout(timer);
            timer = setTimeout(function () {
                if (!chart.isDisposed()) chart.resize();
            }, 150);
        }
    });
    ro.observe(dom);
    // 扩展 dispose，同时断开 observer
    var origDispose = chart.dispose.bind(chart);
    chart.dispose = function () {
        clearTimeout(timer);
        ro.disconnect();
        origDispose();
    };
}

// ── 公开 API ────────────────────────────────────────────────────────────────

/** 初始化 ECharts 实例（自动监听容器 resize，dispose 时自动清理） */
ttx.chart.init = function (dom, theme) {
    var chart = getEcharts().init(dom, theme);
    _autoResize(chart, dom);
    return chart;
};

/** 柱状图快捷方法 */
ttx.chart.bar = function (dom, opts) {
    var chart = ttx.chart.init(dom);
    chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 16, top: 16, bottom: 28 },
        xAxis: { type: 'category', data: opts.categories || [], axisLabel: { fontSize: 10 } },
        yAxis: { type: 'value', axisLabel: { fontSize: 10 } },
        series: (opts.series || []).map(function (s) {
            return { type: 'bar', data: s.data, name: s.name, color: s.color };
        }),
    });
    return chart;
};

/** 折线图快捷方法 */
ttx.chart.line = function (dom, opts) {
    var chart = ttx.chart.init(dom);
    chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 40, right: 16, top: 16, bottom: 28 },
        xAxis: { type: 'category', data: opts.categories || [], axisLabel: { fontSize: 10 } },
        yAxis: { type: 'value', axisLabel: { fontSize: 10 } },
        series: (opts.series || []).map(function (s) {
            return { type: 'line', data: s.data, name: s.name, color: s.color, smooth: true };
        }),
    });
    return chart;
};

/** 饼图快捷方法 */
ttx.chart.pie = function (dom, opts) {
    var chart = ttx.chart.init(dom);
    chart.setOption({
        tooltip: { trigger: 'item' },
        series: [{
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['50%', '50%'],
            label: { fontSize: 10 },
            data: opts.data || [],
        }],
    });
    return chart;
};
